import React from 'react'
import moneyImg from '../assets/img/money.png'
import coinImg from '../assets/img/coin.png'
import shieldImg from '../assets/img/shield.png'

export const SecurityWays = () => {
    const securityCards = [
        {id: 1, title: 'Фонд защиты в размере 100млн $', image: moneyImg, text: 'Полное и мгновенное покрытие в случае проблем платформы'},
        {id: 2, title: 'Резервы обеспечены в соотношении 1:1 и более', image: coinImg, text: 'Проверяется в реальном времени и доступно в любое время'},
        {id: 3, title: 'Страховой фонд фьючерсов', image: shieldImg, text: 'Защита от экстремальных ситуаций на рынке'},
    ]
  return (
    <div id="security-ways">
        <div className="container">
            <div className="security-ways">
                <div className="heading">
                    <h1>Три основные меры по обеспечению безопасности активов</h1>
                    <div className="big-grey">Мгновенный мониторинг рисков ваших активов с оперативной и полной компенсацией убытков, вызванных проблемами на платформе</div>
                </div>
                <div className="security-cards">
                    {
                        securityCards.map(card => (
                            <div className="card security-card" key={card.id}>
                                <div className="card-security-image">
                                    <img src={card.image} alt="" />
                                </div>
                                <div className="security-box-txt">
                                    <div className="security-title">{card.title}</div>
                                    <span>{card.text}</span>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    </div>
  )
}
